/**
  Translation strings for widgets and templates, organized based on regions.
  TODO: Provide user an UI to update translations.
**/
module.exports = {
  PREV_ARTICLE: {
    US: 'Previous Article',
    CN: '上一篇'
  },
  NEXT_ARTICLE: {
    US: 'Next Article',
    CN: '下一篇'
  },
  POSTED_BY: {
    US: 'Posted by',
    CN: '发布人'
  },
  BACK_TO_INDEX: {
    US: 'Back to Index',
    CN: '返回主页'
  },
  TAGS: {
    US: 'Tags',
    CN: '标签'
  },
  READ_MORE: {
    US: 'Read More',
    CN: '阅读更多'
  },
  ERROR_US_ZIP_CODE: {
    US: 'Please enter a valid U.S. zip code.',
    CN: '请输入有效美国邮政编码'
  },
  ERROR_VALID_EMAIL: {
    US: 'Please enter a valid email address',
    CN: '请输入有效邮箱'
  },
  ERROR_REQUIRED_FIELD: {
    US: 'Please fill in the field.',
    CN: '此项为必填项'
  },
  UPCOMING_EVENTS: {
    US: 'Upcoming',
    CN: '近期活动'
  },
  ONGOING_EVENTS: {
    US: 'Ongoing',
    CN: '当前活动'
  },
  PAST_EVENTS: {
    US: 'Past',
    CN: '以往活动'
  },
  EVENT_DETAILS: {
    US: 'Event Details',
    CN: '活动详情'
  },
  ADD_TO_CALENDAR: {
    US: 'Add to Calendar',
    CN: '添加到日历'
  },
  TO: {
    US: 'to',
    CN: '至'
  },
  NO_EVENTS: {
    US: 'There are no',
    CN: '此项目下暂时没有活动事件。'
  },
}
